import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { resetCurrentUserId } from '../services/apiClient';
import { wsService } from '../services/websocket';

/**
 * Clear identity-derived state on account changes and refresh the next socket
 * handshake after silent renewal. HTTP clients read current OIDC storage for
 * every request instead of retaining a default Authorization header.
 */
const ApiBridge: React.FC = () => {
  const auth = useAuth();
  const accessToken = auth.user?.access_token;
  const subject = auth.user?.profile.sub;

  useEffect(() => {
    resetCurrentUserId();
    localStorage.removeItem('instructor-auth');
  }, [subject]);

  useEffect(() => {
    wsService.setAccessToken(accessToken ?? null);
  }, [accessToken]);

  return null;
};

export default ApiBridge;
